module.exports = __webpack_public_path__ + "wake.svg?80b7c6aa7653d0a330401f0858fc61fd";